import { createApi } from "@reduxjs/toolkit/query/react";
import fetchBaseQueryCSRF from "../helper";

const competitorsMonitoring = createApi({
  baseQuery: fetchBaseQueryCSRF({ baseUrl: process.env.CROSS_API_URL }),
  reducerPath: 'api.competitorsMonitoring',
  tagTypes: ['competitorsMonitoring'],
  endpoints: (builder) => ({
    getPres: builder.query<any, { display?: any, compareStartDate: string | null, compareEndDate: string | null, startDate: string | null, endDate: string | null, device: string[] | null, countries: string[], keywords: string[], timestep: string, workspaceId: any | null, domain: string | null, platform: any, campaignType: string | null }>({
      query: ({ display, startDate, endDate, device, countries, keywords, timestep, compareStartDate, compareEndDate, workspaceId, domain, platform, campaignType }) => {
        const url = `/competitorsMonitoring/getPres`;
        const body = {
          display,
          startDate,
          endDate,
          compareStartDate,
          compareEndDate,
          device,
          countries,
          keywords,
          timestep,
          workspaceId,
          domain,
          platform,
          campaignType
        };

        return {
          url,
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),
    getPresence: builder.query<any, { friendlyDomains: any, compareStartDate: string | null, compareEndDate: string | null, startDate: string | null, endDate: string | null, device: string[] | null, countries: string[], keywords: string[], timestep: string, workspaceId: any | null, domain: string | null, platform: any, campaignType: string | null }>({
      query: ({ friendlyDomains, startDate, endDate, device, countries, keywords, timestep, compareStartDate, compareEndDate, workspaceId, domain, platform, campaignType }) => {
        const url = `/competitorsMonitoring/getPresence`;
        const body = {
          startDate,
          endDate,
          compareStartDate,
          compareEndDate,
          device,
          countries,
          keywords,
          timestep,
          workspaceId,
          domain,
          platform,
          campaignType,
          friendlyDomains
        };

        return {
          url,
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),
    getBrand: builder.query<any, { domain: string }>({
      query: ({ domain }) => ({
        url: `/competitorsMonitoring/brands/${domain}`,
        method: 'GET',
      }),
    }),
    getPresenceSpecificDomain: builder.query<any, { compareStartDate: string | null, compareEndDate: string | null, startDate: string | null, endDate: string | null, device: string[] | null, countries: string[], keywords: string[], timestep: string, workspaceId: any | null, additionalDomain: string, platform: any }>({
      query: ({ startDate, endDate, device, countries, keywords, timestep, workspaceId, additionalDomain, compareStartDate, compareEndDate, platform }) => {
        const url = `/competitorsMonitoring/getPresence/specificDomain`;
        const body = {
          startDate,
          endDate,
          compareStartDate,
          compareEndDate,
          device,
          countries,
          keywords,
          timestep,
          workspaceId,
          additionalDomain,
          platform
        };

        return {
          url,
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),
    getAdsTxt: builder.query<any, { domain: string, workspaceTable: any, startDate: string | null, endDate: string | null, device: string[] | null, countries: string[], keywords: string[], platform: any }>({
      query: ({ domain, workspaceTable, startDate, endDate, device, countries, keywords, platform }) => {
        const url = `/competitorsMonitoring/getAdsTxt`;
        const body = {
          startDate,
          endDate,
          device,
          countries,
          keywords,
          workspaceTable,
          domain,
          platform
        };
        return {
          url,
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),
    getAdsTxtGlobal: builder.query<any, {
      domain: string,
      workspaceTable: any,
      startDate: string | null,
      endDate: string | null,
      device: string[] | null,
      countries: string[],
      keywords: string[],
      page?: number,
      sortBy?: any,
      sortOrder?: any,
      pageSize?: number,
      impressionShare: [number, number],
      position: [number, number],
      brands?: string[],
      domains: any,
      otherDomains: any,
      includeOwnDomain?: boolean,
      search?: any,
      platform: any
    }>({
      query: ({
        domain,
        workspaceTable,
        startDate,
        endDate,
        device,
        sortBy,
        sortOrder,
        domains,
        otherDomains,
        includeOwnDomain,
        countries,
        keywords,
        page,
        pageSize,
        impressionShare,
        position,
        brands,
        search,
        platform
      }) => {
        const url = `/competitorsMonitoring/getAdsTxtGlobal`;
        const body = {
          startDate,
          endDate,
          device,
          countries,
          keywords,
          sortBy,
          sortOrder,
          workspaceTable,
          domain,
          otherDomains,
          includeOwnDomain,
          page,
          domains,
          pageSize,
          brands,
          impressionShare,
          position,
          search,
          platform
        };
        return {
          url,
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),
    getAdsPla: builder.query<any, { domain: string, workspaceTable: any, startDate: string | null, endDate: string | null, device: string[] | null, countries: string[], keywords: string[], platform: any }>({
      query: ({ domain, workspaceTable, startDate, endDate, device, countries, keywords, platform }) => {
        const url = `/competitorsMonitoring/getAdsPla`;
        const body = {
          startDate,
          endDate,
          device,
          countries,
          keywords,
          workspaceTable,
          domain,
          platform
        };
        return {
          url,
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),
    getAdsPlaGlobal: builder.query<any, {
      domain: string,
      workspaceTable: any,
      startDate: string | null,
      endDate: string | null,
      otherDomains: any,
      device: string[] | null,
      countries: string[],
      keywords: string[],
      page?: number,
      advertizer: any;
      sortBy?: any,
      sortOrder?: any,
      pageSize?: number,
      brands?: string[],
      domains: any,
      ratingRange: [number, number],
      impressionShare: [number, number],
      position: [number, number],
      priceRange: any,
      includeOwnDomain?: boolean,
      search?: any,
      platform: any
    }>({
      query: ({
        domain,
        workspaceTable,
        startDate,
        endDate,
        device,
        sortBy,
        impressionShare,
        sortOrder,
        advertizer,
        otherDomains,
        domains,
        countries,
        keywords,
        page,
        pageSize,
        brands,
        position,
        ratingRange,
        priceRange,
        includeOwnDomain,
        search,
        platform
      }) => {
        const url = `/competitorsMonitoring/getAdsPlaGlobal`;
        const body = {
          startDate,
          endDate,
          device,
          countries,
          advertizer,
          keywords,
          sortBy,
          position,
          sortOrder,
          workspaceTable,
          otherDomains,
          impressionShare,
          domain,
          page,
          domains,
          pageSize,
          brands,
          ratingRange,
          priceRange,
          includeOwnDomain,
          search,
          platform
        };
        return {
          url,
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),
    getBrands: builder.query<any, { bqTable: string }>({
      query: ({ bqTable }) => ({
        url: `/competitorsMonitoring/getBrands?bqTable=${encodeURIComponent(bqTable)}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          Accept: 'application/json',
        },
      }),
    }),
    getCompetitiveIntelligenceKpis: builder.query<any, {
      startDate: string | null,
      endDate: string | null,
      compareStartDate: string | null,
      compareEndDate: string | null,
      countries: string[],
      devices: string[],
      keywords: string[],
      platforms: any,
      timestep: string,
      workspaceId: any | null
    }>({
      query: ({ startDate, endDate, compareStartDate, compareEndDate, countries, devices, keywords, platforms, timestep, workspaceId }) => {
        const url = `/competitiveintelligence/overview/kpis`;
        const body = {
          startDate,
          endDate,
          compareStartDate,
          compareEndDate,
          countries,
          devices,
          keywords,
          platforms,
          timestep,
          workspaceId
        };

        return {
          url,
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),
    getCompetitionEvolutionKpis: builder.query<any, {
      startDate: string | null,
      endDate: string | null,
      compareStartDate: string | null,
      compareEndDate: string | null,
      countries: string[],
      devices: string[],
      keywords: string[],
      adType: any,
      timestep: string,
      workspaceId: any | null
    }>({
      query: ({ startDate, endDate, compareStartDate, compareEndDate, countries, devices, keywords, adType, timestep, workspaceId }) => {
        const url = `/competitiveintelligence/search-term-analysis/kpis`;
        const body = {
          startDate,
          endDate,
          compareStartDate,
          compareEndDate,
          countries,
          devices,
          keywords,
          adType,
          timestep,
          workspaceId
        };

        return {
          url,
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),
    getCompetitionEvolution: builder.query<any, {
      startDate: string | null,
      endDate: string | null,
      devices: string[],
      keywords: string[],
      platforms: any,
      workspaceId: any | null,
      isAbsMode: any,
      adType: any,
      rateMode: any,
      timestep: any,
      selectedCountry: any,
      selectedDomains: any
    }>({
      query: ({ startDate, endDate, devices, keywords, platforms, workspaceId, isAbsMode, rateMode, adType, timestep, selectedCountry, selectedDomains }) => {
        const url = `/competitiveIntelligence/evolution/getCompetitionEvolution`;
        const body = { startDate, endDate, devices, keywords, platforms, workspaceId, isAbsMode, rateMode, adType, timestep, selectedCountry, selectedDomains };
        return {
          url,
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),
    getSerpContent: builder.mutation<any, { gcsUrl: string }>({
      query: ({ gcsUrl }) => {
        const url = `/competitorsMonitoring/getSerpContent`;
        const body = { gcsUrl };

        return {
          url,
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),
    getAvailableDomains: builder.query<any, {
      startDate: string | null,
      endDate: string | null,
      workspaceId: any,
      selectedCountry?: any,
      adType?: string[],
      devices?: string[],
      platforms?: string[],
      keywords?: string[],
      timestep?: string,
    }>({
      query: ({
        startDate,
        endDate,
        workspaceId,
        selectedCountry,
        adType,
        devices,
        platforms,
        keywords,
        timestep
      }) => {
        const url = `/competitiveIntelligence/evolution/getAvailableDomains`;
        const body = {
          startDate,
          endDate,
          workspaceId,
          selectedCountry,
          adType,
          devices,
          platforms,
          keywords,
          timestep,
        };

        return {
          url,
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),

    countries: builder.query<any, {
      workspace: any,
      platforms: any,
      startDate: any,
      endDate: any
    }>({
      query: ({ workspace, platforms, startDate, endDate }) => {
        const url = `/competitorsMonitoring/filters/countries`;
        const body = {
          workspace,
          platforms,
          startDate,
          endDate
        };

        return {
          url,
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),

    searchTerms: builder.query<any, {
      workspace: any,
      platforms: any,
      devices: any,
      startDate: any,
      endDate: any
    }>({
      query: ({ workspace, platforms, startDate, endDate, devices }) => {
        const url = `/competitorsMonitoring/filters/search-terms`;
        const body = {
          workspace,
          platforms,
          devices,
          startDate,
          endDate
        };

        return {
          url,
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),
  }),
});

export const {
  useGetPresenceQuery,
  useGetBrandQuery,
  useGetPresenceSpecificDomainQuery,
  useGetAdsTxtQuery,
  useGetAdsPlaQuery,
  useGetBrandsQuery,
  useGetAdsPlaGlobalQuery,
  useGetAdsTxtGlobalQuery,
  useGetPresQuery,
  useGetCompetitiveIntelligenceKpisQuery,
  useGetCompetitionEvolutionKpisQuery,
  useGetCompetitionEvolutionQuery,
  useGetSerpContentMutation,
  useGetAvailableDomainsQuery,

  useCountriesQuery,
  useSearchTermsQuery
} = competitorsMonitoring;

export default competitorsMonitoring;
